import logo from '../../assets/LOGO (2).png';

export default function SidebarLogo({ isCompact }) {
  return (
    <div className={`flex items-center justify-center transition-all duration-300 ${isCompact ? 'mb-4' : 'mb-5'}`}>
      <div className={`flex items-center justify-center rounded-lg bg-white transition-all duration-300 ${
        isCompact ? 'h-10 w-10 mb-4' : 'h-12 w-12'
      }`}>
        <img src={logo} alt="Easy Survey" className={`transition-all duration-300 ${
          isCompact ? 'h-6 w-6' : 'h-8 w-8'
        }`} />
      </div>
    </div>
  );
}
